import React, { useState } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, TextField, Button
} from '@mui/material';

const GoaRequestDialog = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      // Optionally show an error message if reason is empty
      return;
    }
    setIsSubmitting(true);
    try {
      await onSubmit(reason);
      handleClose(); // Close dialog on successful submission
    } catch (error) {
      console.error("Error submitting GOA request:", error);
      // Optionally show an error message to the user
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setReason(''); // Reset reason on close
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Request GOA (Gone On Arrival)</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Please provide a reason for marking this job as Gone On Arrival. This will be sent for approval.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="goa-reason"
          label="Reason"
          type="text"
          fullWidth
          variant="outlined"
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isSubmitting}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={!reason.trim() || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Request'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GoaRequestDialog;